import React, { ReactNode } from 'react'
import styles from '../../styles/user/ProgressBox.module.scss'
import SignInHeader from '../admin/SignInHeader'
import Greeting from '../common/Greeting'
import ContentBox from './ContentBox'
import SignInLayout from './SignInLayout'
import ProgressBox from '../user/ProgressBox'
import { useAuthStore } from '../../store/useAuthStore'
import { useUserStore } from '../../store/useUserStore'
import ProgressBoxMobile from '../user/ProgressBoxMobile'

type LayoutType = 'none' | 'standard' | 'secondary' | 'tertiary'

interface SignInPageProps {
  content: ReactNode
  layout?: LayoutType
  hasGreeting?: boolean
}

const ProgressPage: React.FC<SignInPageProps> = ({
  content,
  layout = 'none',
  hasGreeting = false,
}) => {
  const user = useAuthStore((state) => state.user)
  const userProfile = useUserStore((state) => state.userProfile)
  const userName = userProfile?.nickname || user?.NICKNAME || 'User'

  return (
    <SignInLayout>
      <SignInHeader />
      <div className={styles.progressWrapper}>
        <img
          src="/assets/confetti.png"
          alt="confetti"
          className={styles.confetti}
        />
        <div className={styles.welcomeMessage}>Welcome {userName}</div>
        <img
          src="/assets/confetti-monsters.png"
          alt="confetti-monsters"
          className={styles.confettiImage}
        />
        <div className={styles.desktopOnly}>
          <ProgressBox />
        </div>

        <div className={styles.mobileOnly}>
          <ProgressBoxMobile />
        </div>
      </div>
      <img src="/assets/cup.png" alt="Cup" className={styles.cup} />
    </SignInLayout>
  )
}

export default ProgressPage
